import axios from 'axios';
import TomSelect from 'tom-select';

declare let booking_object: any;

export default class getInitGames{

    /**
     * Get rooms
     * @returns 
     */
    get(
        el_rooms: string,
        el_games: string,
        el_time_slot: string,
        book_calendar: any,
        get_players: any,
        modPlayers: any,
        modTimeSlot: any
    ){

        // Element room
        const elRoom = document.querySelector(el_rooms) as HTMLSelectElement | null;
        
        // Element game
        const elGame = document.querySelector(el_games) as HTMLSelectElement | null;

        // Get date
        const get_date = book_calendar.getDate('y/mm/dd');

        // Settings
        const settings: any = {
            plugins: ['dropdown_input'],
            valueField: 'id',
            labelField: 'name',
            searchField: 'name',
            preload: true,
            load: function (query, callback) {

                const q = {
                    'name': query
                }
                
                // Post data
                const post_data = {
                    'room_id': (elRoom !== null) ? elRoom.value : '',
                    'date': get_date
                };
            
                // Query string
                const queryString = new URLSearchParams(post_data).toString();
    
                // Call ajax
                axios.post(booking_object.rest_urls.get_games_by_room, queryString)
                    .then(function (response: any) {
    
                        callback(response.data);

                    })
                    .catch(function (error: any) {
    
                        console.log(error);
    
                    });
            },
            onItemAdd(value, item) {

                const parser = new DOMParser();
                const el = parser.parseFromString(item.outerHTML, "text/html");
                const elSpan = el.body.firstChild as HTMLSpanElement;
                const min_player_works = elSpan.dataset.players as unknown as number;
                const min_player_holidays = elSpan.dataset.players as unknown as number;
                const n_players = elSpan.dataset.players as unknown as number;

                // Set players
                // modPlayers.setPlayers(get_players, n_players, get_date, min_player_works, min_player_holidays);

            },
            render: {
                option: function (item, escape) {
                    return '<span class="block w-full fluid-text-xs">' + escape(item.name) + '</span>';
                },
                item: function (item, escape) {

                    const min_player_works = (typeof item.min_player_works === 'undefined') ? null : escape(item.min_player_works);

                    const min_player_holidays = (typeof item.min_player_holidays === 'undefined') ? null : escape(item.min_player_holidays);

                    return '<span data-plworks="' + min_player_works + '" data-plholidays="' + min_player_holidays + '" data-players="' + escape(item.max_players) + '">' + escape(item.name) + '</span>';
                },
            }
        };

        const control: TomSelect = new TomSelect(el_games, settings);

        if(elRoom !== null){
            
            const val_room = elRoom.value;
            
            if (val_room.length === 0) {
            
                if (elGame !== null) {
            
                    control.disable();
                
                }
                
            }

        }

        // Change room and get games
        this.changeRoomGamesSelect(elRoom, control);

        // Change game
        this.changeGameSelect(
            el_rooms,
            el_games,
            el_time_slot,
            book_calendar,
            get_players,
            modPlayers,
            modTimeSlot,
        );

    }

    /**
     * Change room games
     * @param elRoom 
     * @param control 
     */
    protected changeRoomGamesSelect(elRoom: HTMLSelectElement | null, control: TomSelect){
        
        const _that = this;
        
        elRoom?.addEventListener('change', function(e){
    
            const elValue = e.target as HTMLSelectElement;
            
            control.enable();
            control.clear();
            control.clearOptions();
    
            // Post data
            const post_data = {
                'room_id': elValue.value,
            };
        
            // Query string
            const queryString = new URLSearchParams(post_data).toString();
    
            // Call ajax
            axios.post(booking_object.rest_urls.get_games_by_room, queryString)
            .then(function (response: any) {
    
                control.addOptions(response.data, false);
                
                control.setValue([response.data.data[0].id]);
    
            })
            .catch(function (error: any){
    
                console.log(error);
    
            });
            
        });
        
    }

    /**
     * Change game
     * @param elGame 
     */
    protected changeGameSelect(
        el_rooms: string,
        el_games: string,
        el_time_slot: string,
        book_calendar: any,
        get_players: any,
        modPlayers: any,
        modTimeSlot: any,
    ){
        
        const _that = this;

        // Element room
        const elRoom = document.querySelector(el_rooms) as HTMLSelectElement | null;
        
        // Element game
        const elGame = document.querySelector(el_games) as HTMLSelectElement | null;
        
        elGame?.addEventListener('change', function(e){
    
            const elValue = e.target as HTMLSelectElement;

            // Get date
            const get_date = book_calendar.getDate('y/mm/dd');

            // Post data
            const post_data = {
                'room_id': (elRoom !== null) ? elRoom?.value : '',
                'game_id': elValue.value
            };
        
            // Query string
            const queryString = new URLSearchParams(post_data).toString();
    
            // Call ajax
            axios.post(booking_object.rest_urls.change_game, queryString)
            .then(function (response: any) {
                
                const min_player_works: number = response.data.data.min_player_works;
                const min_player_holidays: number = response.data.data.min_player_holidays;
                const n_players: number = response.data.data.max_players;

                // Set players
                modPlayers.setPlayers(get_players, n_players, get_date, min_player_works, min_player_holidays);

                // Change time slot
                modTimeSlot.changeRoomTimeSlotSelect(
                    book_calendar,
                    (elRoom !== null) ? elRoom?.value : '',
                    elValue.value,
                    el_time_slot
                );
                
            })
            .catch(function (error: any){
    
                console.log(error);
    
            });
            
        });
        
    }

}